import "./accent-checkbox.scss";
import {
	type ChangeEvent,
	type ComponentPropsWithoutRef,
	type ReactNode,
	forwardRef,
} from "react";

export type AccentCheckboxProps = Omit<
	ComponentPropsWithoutRef<"input">,
	"type" | "onChange" | "children"
> & {
	onChange?: (checked: boolean, event: ChangeEvent<HTMLInputElement>) => void;
	children?: ReactNode;
};

export const AccentCheckbox = forwardRef<HTMLInputElement, AccentCheckboxProps>(
	function AccentCheckbox(
		{ className, children, onChange, disabled, ...rest },
		ref,
	) {
		return (
			<label
				className={[
					"accent-checkbox",
					disabled ? "accent-checkbox--disabled" : "",
					className ?? "",
				]
					.join(" ")
					.trim()}>
				<input
					ref={ref}
					type='checkbox'
					className='accent-checkbox__input'
					disabled={disabled}
					onChange={(e) => onChange?.(e.target.checked, e)}
					{...rest}
				/>
				<span className='accent-checkbox__box' aria-hidden />
				{children != null ? (
					<span className='accent-checkbox__label'>{children}</span>
				) : null}
			</label>
		);
	},
);
